import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import DynamicGoogleFormSubmitter from "src/components/Form/DynamicGoogleFormSubmitter";
import { FaCircle } from "react-icons/fa";
import TournamentDropDownText from "src/pages/poker/tournaments/TournamentDropDownText";
import { FaGlassMartiniAlt, FaUserTie, FaGamepad, FaDollarSign } from "react-icons/fa";

const UltimateDad2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <UltimateDadDiv>
      <EventFinished scheduleKeyName="ultimateDad2025" />
      <Hero
        image={`promotions/gaming-machines/the-ultimate-dad-night-2025/ultimate-dad-night-logo-2400x2400px-${i18n.language}.png`}
        bgImage="promotions/gaming-machines/the-ultimate-dad-night-2025/ultimate-dad-night-hero-image-2400x800px.jpg"
        buttonSettings={null}
        darkenBg={0.5}
        title={t("ultimateDad2025.hero.title")}
        descriptionBgColor="#0000004d"
      />
      <OrangeBanner>
        <h2>{t("ultimateDad2025.content.title").toUpperCase()}</h2>
      </OrangeBanner>

      <MainContentDiv>
        <container-div>
          <BlueTextSection>
            <h2>{t("ultimateDad2025.content.subTitle").toUpperCase()}</h2>
            <p>{t("ultimateDad2025.content.celebrate")}</p>
          </BlueTextSection>

          <PrizeSection>
            <h2>{t("ultimateDad2025.content.text").toUpperCase()}</h2>
            <p>{t("ultimateDad2025.content.detailsTitle")}</p>
          </PrizeSection>
        </container-div>

        <BluePrizesSection bgImage={useResponsiveImageUrl(
          "promotions/gaming-machines/the-ultimate-dad-night-2025/blue-bricks-2400x725px.jpg"
        )}>
          <container-div>
            <div className="inner">
              <h3>{t("ultimateDad2025.content.prizes.featuring")}</h3>
              <Row className="prize-icons">
                <Col xs={6} md={3}>
                  <PrizeIcon>
                    <ResponsiveImage
                      src={"promotions/gaming-machines/the-ultimate-dad-night-2025/wine.png"}
                    />
                    <div className="prize-text">
                      <p>{t("ultimateDad2025.content.prizes.dinner")}</p>
                    </div>
                  </PrizeIcon>
                </Col>
                <Col xs={6} md={3}>
                  <PrizeIcon>
                    <ResponsiveImage
                      src={"promotions/gaming-machines/the-ultimate-dad-night-2025/poker.png"}
                    />
                    <div className="prize-text">
                    <p>{t("ultimateDad2025.content.prizes.poker")}</p>
                    </div>
                  </PrizeIcon>
                </Col>
                <Col xs={6} md={3}>
                  <PrizeIcon>
                    <ResponsiveImage
                      src={`promotions/gaming-machines/the-ultimate-dad-night-2025/freeplay-${i18n.language}.png`}
                    />
                    <div className="prize-text">
                    <p>{t("ultimateDad2025.content.prizes.freePlay")}</p>
                    </div>
                  </PrizeIcon>
                </Col>
                <Col xs={6} md={3}>
                  <PrizeIcon>
                    <ResponsiveImage
                      src={"promotions/gaming-machines/the-ultimate-dad-night-2025/host.png"}
                    />
                    <div className="prize-text">
                    <p>{t("ultimateDad2025.content.prizes.privateHost")}</p>
                    </div>
                  </PrizeIcon>
                </Col>
              </Row>
            </div>
          </container-div>
        </BluePrizesSection>

        <BonusPrizeSection>
          <h3>{t("ultimateDad2025.content.extraPrize")}</h3>
          <PrizeIcon>
            <ResponsiveImage
            className="mb-1"
            src={`promotions/gaming-machines/the-ultimate-dad-night-2025/freeplay-${i18n.language}.png`}
            />
          </PrizeIcon>
            <div className="prize-text">
              <p>{t("ultimateDad2025.content.extraPrizeDetails")}</p>
            </div>
        </BonusPrizeSection>

        <EnterNowSection>
          <h3>{t("wsopcForm.enterNow")}</h3>
          <p>{t("wsopcForm.qualify")}</p>
        </EnterNowSection>

        <Row>
          <Col xs={12} md={12} lg={8} className="mx-auto">
            <DynamicGoogleFormSubmitter
              formId="AKfycbzJdRaXa_gM49HiYSuiy--T9gb-IlESnhJkttOpnSqwGXWhIrt27-_B8lH2PddQ66DXQw"
              formTextKey="ultimateDad2025"
              titles={false}
              formFields={[
                {
                  id: "FirstName",
                  label: "firstName",
                  type: "text",
                  required: true
                },
                {
                  id: "LastName",
                  label: "lastName",
                  type: "text",
                  required: true
                },
                {
                  id: "Email",
                  label: "email",
                  type: "email",
                  required: true
                },
                {
                  id: "PhoneNumber",
                  label: "phoneNumber",
                  type: "text",
                  required: true
                },
                {
                  id: "PlayerID",
                  label: "pgPlayerId",
                  type: "text",
                  required: false,
                  placeholder: "pgPlayerIdPlaceholder"
                },
                {
                  id: "FatherNominee",
                  label: "fatherNominee",
                  type: "text",
                  required: true
                }
              ]}
            />
          </Col>
        </Row>

        <Row className="mt-4">
          <Col xs={12} md={12} lg={8} className="mx-auto">
            <TermsBox bgImage={useResponsiveImageUrl(
                "promotions/gaming-machines/the-ultimate-dad-night-2025/blue-bricks-2400x725px.jpg"
              )}>
              <div className="inner">
                <TitleSection
                  as={"h3"}
                  dark
                  title={t("ultimateDad2025.content.termsTitle")}
                  borderColor="var(--mutedred)"
                  className="pt-0 pb-0"
                />
                <ReactMarkdown>{t("ultimateDad2025.content.terms")}</ReactMarkdown>
                <TournamentDropDownText
                  dropdownText={{
                    label: t("ultimateDad2025.content.fullTermsLabel"),
                    list: t("ultimateDad2025.content.fullTerms"),
                  }}
                />
              </div>
            </TermsBox>
          </Col>
        </Row>
      </MainContentDiv>
    </UltimateDadDiv>
  );
};

const UltimateDadDiv = styled.div`
  width: 100%;
  height: auto;
  background: #000;
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 0 2rem;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #CBB695;
  }
  .tournament-drop-down-text {
    margin-bottom: 0;
    button {
      width: 100%;
      max-width: initial;
      height: auto;
      padding: 0.7rem;
      background-color: #111;
      color: var(--mutedwhite);
    }
  }
`;

const OrangeBanner = styled.div`
  background-color: #FF5500;
  width: 100%;
  padding: 1rem;
  text-align: center;

  h2 {
    color: white;
    font-weight: bold;
    margin: 0;
    font-size: 2rem;
    text-transform: uppercase;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.5rem;
    }
  }
`;

const BlueTextSection = styled.div`
  color: #00AEEF;
  text-align: center;
  margin: 2rem 0;

  h2 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const PrizeSection = styled.div`
  text-align: center;
  margin: 2rem 0;

  h2 {
    color: #FF5500;
    font-size: 2.5rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 1.8rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const BluePrizesSection = styled.div`
  background-color: #005A9C;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  padding: 2rem 1rem;
  margin: 0;
  text-align: center;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }

  .inner {
    position: relative;
    z-index: 2;
    h3 {
      color: white;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 2rem;
      text-transform: uppercase;
    }

  }


  @media (max-width: 768px) {
    h3 {
      font-size: 1.5rem;
    }
  }
`;

const PrizeIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;

  img {
    max-height: 100px;
    height: auto;
    margin-bottom: 2rem;
  }

  .prize-text {
    color: white;
    text-align: center;
    p {
      font-size: 1.3rem;
      margin: 0;
      line-height: 1.3;
    }
  }

  @media (max-width: 768px) {
    svg {
      font-size: 2.5rem;
    }
    .prize-text p {
      font-size: 0.9rem;
    }
  }
`;

const BonusPrizeSection = styled.div`
  background-color: #111;
  padding: 2rem 1rem;
  text-align: center;

  h3 {
    color: #FF5500;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 1.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const EnterNowSection = styled.div`
  text-align: center;
  margin: 2rem 0;

  h3 {
    color: #00AEEF;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
  }

  p {
    font-size: 1.2rem;
    color: white;
  }

  @media (max-width: 768px) {
    h3 {
      font-size: 1.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  background-color: #000;

  @media (min-width: 768px) {
    padding: 0 1rem 1rem;
  }

  @media (min-width: 992px) {
    padding: 0 0 3rem;
  }

  height: auto;
  width: 100%;

  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
  }
`;

const TermsBox = styled.div`
  padding: 2rem 1rem;
  margin: 2rem 0;
  border-radius: 0.5rem;
  color: var(--white);
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
  }
  .inner {
    position: relative;
    z-index: 2;
    h3 {
      color: var(--white);
    }
    strong {
      color: #CBB695;
    }
    p {
      margin-bottom: 1rem;
    }
    ul {
      margin-top: 1rem;
      margin-bottom: 1rem;
      p {
        margin: 10px 0;
      }
      li {
        white-space: unset;
        list-style: none;
        margin-bottom: 0.5rem;
        &:before {
          content: "•";
          color: #FF5500;
          font-weight: bold;
          display: inline-block;
          width: 1em;
          margin-left: -1em;
        }
      }
    }
  }

`;

export default UltimateDad2025;
